import React, { useState } from "react";
import DataTable from "./Table";
import { Form } from "react-bootstrap";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function RetakeSubmissionManager(props) {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    // Sets the filtered data to the data from firebase
    setFilteredData(props.data);
  }, [props.data]);


    return (
    <div className="container">
        {/* Title */}
        <h2 className="heading-space">{props.title}</h2>
        {/* Output Appointment data here */}
        {!filteredData.length && <p>No retake sign ups found</p>}
        {filteredData.length > 0 && (
          <div className="mx-auto" style={{ maxWidth: "100%" }}>
            {filteredData.length > 0 && <DataTable data={filteredData} showCheckboxes={false} hiddenColumns={["id"]}/>}
          </div>
        )}
      </div>
    );
  };

export default RetakeSubmissionManager;
